<template>
    <div id="menu">
        <img class="close-menu" src="@/assets/img/icons/shape@3x.png" @click="closeMenu">
        <div class="m-section-container">
            <div class="m-section-1">
                <div class="m-s-links">
                    <MenuItem :key="item.index" v-for="item in itemList" :text="item.text" :link="item.link" :callback="item.callback" />
                </div>
                <div class="m-s-social">
                    <a href="https://www.instagram.com/yarininsuyu/" target="_blank">
                        <img src="@/assets/img/icons/iconfinder-38-instagram-1161954@3x.png" alt="Yarının suyu - Instagram">
                    </a>
                    <a href="https://www.youtube.com/finishturkiye" target="_blank">
                        <img src="@/assets/img/icons/iconfinder-58-youtube-104445@3x.png" alt="Yarının suyu - YouTube">
                    </a>
                    <a href="https://www.facebook.com/yarininsuyu/" target="_blank">
                        <img src="@/assets/img/icons/facebook-2@3x.png" alt="Yarının suyu - Facebook">
                    </a>
                </div>
            </div>
            <div class="m-section-2">
                <div container style="overflow-y:visible;">
                    <ButtonWithImage :text="'Türkiye’nin Su Kaynaklarını TAKİP ETMENİN artık <br> BİR yolu var'" :image="'finish-su-endeksilogo.png'" :link="`/finish-su-endeksi`" :isBackground="true" @click="closeMenu" />
                    <!--<ButtonWithImage :text="'TANER ÖLMEZ İLE EBA TV SU KAHRAMANLARI'" :image="'z.png'" :link="'to:EbaTV'"  @click="closeMenu"/>-->
                    <!--<ButtonWithImage :text="'FİNİSH QUANTUM MAX İLE 57 LİTRE SU TASARRUFU ETTİREN TABLET'" :link="'to:Story1'" :image="'finish.png'" @click="closeMenu"/>-->
                    <ButtonWithImage :text="'25 LİTRE BELGESELİNİ İZLE'" :image="'athena.png'" :link="'to:Documentary25Litre'"   @click="closeMenu"/>
                </div>

                <WaterPrintPromise />

                <div class="m-s-legal">
                    <div class="m-s-social-mobile">
                        <a href="https://www.instagram.com/yarininsuyu/" target="_blank">
                            <img src="@/assets/img/icons/iconfinder-38-instagram-1161954@3x.png" alt="Yarının suyu - Instagram">
                        </a>
                        <a href="https://www.facebook.com/yarininsuyu/" target="_blank">
                            <img src="@/assets/img/icons/iconfinder-58-youtube-104445@3x.png" alt="Yarının suyu - YouTube">
                        </a>
                        <a href="https://www.youtube.com/finishturkiye" target="_blank">
                            <img src="@/assets/img/icons/facebook-2@3x.png" alt="Yarının suyu - Facebook">
                        </a>
                    </div>
                    <div class="m-s-l-links">
                        <router-link to="/hukuki-sartlar">HUKUKİ ŞARTLAR</router-link>
                        <router-link to="/gizlilik">GİZLİLİK POLİTİKASI</router-link>
                        <router-link to="/cerez-politikasi">ÇEREZ POLİTİKASI</router-link>
<!--                        <router-link to="/iletisim">BİZE ULAŞIN</router-link>-->
                        <a href="https://www.finish.com.tr/bize-ulasin/" target="_blank">BİZE ULAŞIN</a>
                    </div>
                    <div class="m-s-l-copyright">
                        <div>© <span>{{copyrightDate}}</span> Reckitt Benckiser - Tüm hakları saklıdır</div>
                    </div>
                </div>
            </div>
            <div class="m-section-3">
                <WaterPrintPromise />
            </div>
        </div>
    </div>
</template>

<script>
    import MenuItem from "./MenuItem";
    import ButtonWithImage from "./ButtonWithImage";
    import ButtonWithTransparent from "./ButtonWithTransparent";
    import EventBus from "../main";
    import Navigation from "./Navigation";
    import WaterPrintPromise from "./WaterPrintPromise";

    export default {
        name: "Menu",
        data() {
            return {
                copyrightDate : new Date().getFullYear(),
                itemList: [
                    {
                        text: 'YARININ SUYU',
                        link: '#',
                        callback: () => { return false; }
                    },
                    {
                        text: 'SU AYAK İZİNİ HESAPLA',
                        link: '_fn',
                        callback: this.waterPrintStart
                    },
                    {
                        text: 'SEN DE SÖZ VER',
                        link: '_fn',
                        callback: this.promise
                    },
                    {
                        text: 'KUYUCUK GÖLÜNE BİR MİLYON TL',
                        link: 'to:/projeler/kuyucuk',
                        callback: () => { return false; }
                    },
                    {
                        text: '25 LİTRE BELGESELİNİ İZLE',
                        link: 'to:Documentary25Litre',
                        callback: () => { return false; }
                    }
    /* TODO: When client approves, uncomment this section. Currently this campaign is passive.
    ,
    {
        text: 'MÜGE ANLI İLE GÜCÜMÜZ YETER',
        link: 'https://www.gucumuzyeter.com/',
        callback: () => { return false; }
    }*/,
    {
        text: 'SU AKADEMİSİ',
        link: 'to:WaterAcademy',
        callback: () => { return false; }
    },
]
}
},
methods: {
closeMenu() {
EventBus.$emit('menu-status');
},
waterPrintStart() {
this.closeMenu();
dataLayer.push({'event':'sidebarCalculate_startPromiseQuiz','page':window.location.pathname == '/' ? 'homepage' : window.location.pathname.replace('/','')});
EventBus.$emit('water-print-status');
},
promise() {
this.closeMenu();
dataLayer.push({'event':'sidebarPromise_startPromiseQuiz','page':window.location.pathname == '/' ? 'homepage' : window.location.pathname.replace('/','')});
EventBus.$emit('water-print-status');
}
},
created() {
EventBus.$emit('navigation-changed');
},
components: {
WaterPrintPromise,
Navigation,
ButtonWithImage,
MenuItem,
ButtonWithTransparent
}
}
</script>

<style lang="scss">
    #menu {
        display: flex;
        position: fixed;
        flex-direction: column;
        z-index: 15;
        background-color: rgba(0,8,37,0.95);
        width: 100%;
        height: 100%;
        .close-menu {
            position: absolute;
            top: 15px;
            left: 15px;
            width: 38px;
            height: 38px;
            cursor: pointer;
            @media only screen and (max-device-width: 768px) {
                width: 80px;
                height: 80px;
                top: 35px;
                left: 35px;
            }
        }
        .m-section-container {
            display: flex;
            height: 100%;
            div[class*="m-section-"] {
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                width: 100%;
                height: 100%;
                border-right: 1px solid grey;
                .m-s-links {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                }
                .m-s-social {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    width: 70%;
                    margin-top: 55px;

                    a {
                        width: 30px;
                        height: 30px;
                        max-width: 30px;
                        max-height: 30px;
                        margin-right: 15px;
                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
                &[class="m-section-2"] {
                    .overflowed-button {
                        margin-top: 47px;
                        &:nth-of-type(1) {
                            margin-top: auto;
                        }
                    }

                    [container] {
                        justify-content: end;
                        max-height: 65%;
                        overflow-y: auto;
                        margin: auto 0;
                    }


                    /* width */
                    [container]::-webkit-scrollbar {
                        width: 20px;
                    }

                    /* Track */
                    [container]::-webkit-scrollbar-track {
                        box-shadow: inset 0 0 5px grey;
                        border-radius: 10px;
                    }

                    /* Handle */
                    [container]::-webkit-scrollbar-thumb {
                        background: #00a2e2;
                        border-radius: 10px;
                    }


                    .juicy-promise {
                        min-height:380px;
                        display: none;
                    }

                    .m-s-legal {
                        height: 50px;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        align-items: center;
                        margin-top: auto;
                        margin-bottom: 20px;
                        font-size: 11px;
                        .m-s-l-links {
                            display: flex;
                            flex-wrap: wrap;
                            justify-content: center;
                            a,
                            a:link,
                            a:visited,
                            a:active {
                                text-decoration: none;
                                color: white;
                                margin: 2px 5px;
                            }
                        }

                        .m-s-social-mobile {
                            display: none;
                        }
                        
                        .m-s-l-copyright {
                            @media only screen and (max-device-width: 768px) {
                                margin-top: 40px;
                            }
                        }
                    }
                }
                &[class="m-section-3"] {
                    .m-s-3-container {
                        justify-content: center;
                        align-items: center;
                        text-align: center;
                        p {
                            font-size: 20px;
                        }
                        .transparent-button > p {
                            font-size: 12px;
                        }
                    }
                }
            }

            @media only screen and (max-device-width: 768px)  {
                flex-direction: column;
                padding: 85px 0;
                overflow-y: scroll;

                div[class*="m-section-"] {
                    height: auto;
                    margin-top: 75px;
                    .menu-item {
                        width: 90%;
                        margin: 14px auto;

                        .mi-text {
                            font-size: 38px;
                        }
                    }

                    .m-s-social {
                        display: none;
                    }

                    &.m-section-2 {
                        .juicy-promise {
                            display: flex;
                            margin-top: 50px;
                        }

                        .m-s-legal {
                            height: auto;
                            width: 100%;
                            font-size: 25px;

                            .m-s-l-links {
                                margin-top: 25px;
                            }
                        }
                    }

                    &.m-section-3 {
                        display: none;
                    }
                }
                .m-s-social-mobile {
                    justify-content: center;
                    a {
                        width: 110px;
                        height: 110px;
                        max-width: 110px;
                        max-height: 110px;
                        margin-right: 30px;
                    }
                }
            }
        }
    }
</style>
